import React from "react";
import { Box } from "@mui/material";

const PhaseOfCarePage = () => {
  return (
    <Box
      sx={{
        padding: 10,
      }}
    >
      {"WIP: Phase of Care"}
    </Box>
  );
};

export default PhaseOfCarePage;
